import { Button, Space } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';

/** 右上角身份区（供 app.ts 的 rightRender 调用；app.ts 内不得出现 JSX） */
export function renderRightSlot(user: { username: string } | null, onLogout: () => void) {
  if (!user) return null;
  return (
    <Space size={12}>
      <span style={{ color: '#555' }}>
        <UserOutlined style={{ marginRight: 6 }} />
        {user.username}
      </span>
      <Button size="small" icon={<LogoutOutlined />} onClick={onLogout}>
        退出登录
      </Button>
    </Space>
  );
}
